export const allowedFileExtensions = ['png', 'jpeg', 'jpg'];
export const allowedImgTypes = ['image/png', 'image/jpeg'];
